<template>
  <div class="h-full">
    <el-row class="h-full w-full">
      <el-col :span="24" class="h-full">
        <div ref="ysplayer" :class="[className, 'w-full', 'h-full']"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* 宇视——视频播放器 */

import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
/* eslint-disable */
export default {
  props: {
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 获取协议实例需要用到【pIid】,返回的内容包含有ip、端口、用户名、密码
    pIid: {
      type: String,
      defalut: '',
    },
    // 针对实时监控时，在同一个窗口播放不同摄像头监控的标记
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      className: 'ysplayer',
      selectedDatetime: [
        this.dayjs(new Date()).format('YYYY/MM/DD 00:00:00'),
        this.dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss'),
      ], // 回放开始、结束时间
      isHistory: false, // 播放模式；false = 实时播放；true = 历史播放
      streamType: 2, // 码流类型; 1 = 主码流；2 = 辅码流
      iframeObjId: '',
      ipAddress: '',
      username: '',
      password: '',
      port: '',
      curPlayIndex: 0,
    }
  },
  async mounted() {
    // console.log('传入的code和pIid', this.code, this.pIid, this.currentIndex)
    const _this = this
    window.addEventListener('resize', (e) => {
      if (e.keyCode === 27 && _this.streamType === 1) {
        // 1. 播放主码流还是辅码流 1为主码流，2为辅码流
        _this.streamType = 2
        // 2. 播放当前的监控
        _this.playLive()
      }
    })
    await this.getConfig()
  },
  methods: {
    // 登录
    async login() {
      const _this = this
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          // console.log('第一次调登录接口的请求响应状态信息', response)
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error('网络请求失败')
          }
        })
        .then((res) => {
          // console.log('第一次调登录接口的响应结果', res)
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.username)
          const loginSignatureTemp = base64Username + accessCode + this.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          // console.log('加密后的loginSignatureTemp:', loginSignature)
          const data = {
            UserName: this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          // console.log('第二次调用登录接口传的参数:', data)
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              // console.log('第二次调登录接口的请求响应状态信息', response)
              if (response.status === 200) {
                return response.json()
              } else {
                throw new Error('网络请求失败')
              }
            })
            .then((r) => {
              // console.log('第二次调用登录接口的响应结果', r)
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  // console.log('密码错误')
                  break
                case 12351:
                  // console.log('用户不存在')
                  break
                case undefined:
                  window.playerToken = r.AccessToken
                  // console.log(loginResult, '登录成功11')
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 1, '/unv/imosSdk.html')
                    .then(() => {
                      // console.log(loginResult, '登录成功22')
                      // 设置后续事件回调
                      imosSdk.registerLiveMsg((result) => {
                        // console.log(result, '登录成功33')
                        if (result.Type === 'zoom' && result.Zoom === 1) {
                          // console.log(_this.iframeObjId, _this.code, '全屏')
                          // 播放器全屏 - 执行操作 - 惠州驾驶舱-数字工地
                          // 1. 切换到主码流 - 无论如何都需要执行 -
                          _this.streamType = 1 // 播放主码流还是辅码流 1为主码流，2为辅码流
                          // 2. 播放当前的监控

                          // 播放历史回放
                          if (_this.isHistory) {
                            _this.playHistory(
                              _this.iframeObjId,
                              _this.selectedDatetime[0],
                              _this.selectedDatetime[1]
                            )
                            return
                          }

                          // 播放实况
                          _this.playLive()
                        }
                        if (result.Type === 'zoom' && result.Zoom === 0) {
                          // console.log(_this.iframeObjId, _this.code, '退出全屏')

                          // 播放历史回放
                          if (_this.isHistory) {
                            _this.playHistory(
                              _this.iframeObjId,
                              _this.selectedDatetime[0],
                              _this.selectedDatetime[1]
                            )
                            return
                          }

                          // 取消播放器全屏 - 执行操作 - 惠州驾驶舱-数字工地
                          // 1. 缩小切换到辅码流 - 无论如何都需要执行 - 为了清晰度
                          _this.streamType = 2 // 播放主码流还是辅码流 1为主码流，2为辅码流
                          // 2. 播放当前的监控
                          _this.playLive()
                        }
                      })
                    })
                    .catch((err) => {
                      // console.log('调用失败')
                      // console.log(err)
                    })
                  break
                default:
              }
              _this.creatWindow()
            })
            .catch((e) => {
              // console.log('服务器连接异常')
              // console.log(e)
            })
        })
        .catch((error) => {
          // console.log('服务器连接异常123')
          // console.log(error)
        })
    },
    async getConfig() {
      const [err, res] = await iotDeviceProtocolInstanceApi.get(this.pIid)
      if (!err && res?.jsonContent) {
        const parsedInfo = JSON.parse(res.jsonContent)
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    creatWindow() {
      // console.log('进入了createWindow')
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      this.iframeObjId = iframeObj && iframeObj.id
      this.createSpeDiv(iframeObj)
    },
    createSpeDiv(iframeObj) {
      const videoDom = this.$refs.ysplayer
      // 如果传进来的序号和之前的一样，说明没有切换窗口，把原有窗口置空
      if (this.curPlayIndex === this.currentIndex) {
        videoDom.innerHTML = null
      }
      let divDom = document.createElement('div')
      divDom.style = 'height: 100%;'
      divDom.appendChild(iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      this.getCamera()
      this.curPlayIndex = this.currentIndex // 创建窗口成功后，把传进来的序号赋值给data里的curPlayIndex
    },
    getCamera() {
      if (this.code) {
        this.playLive()
      }
    },
    // 实时播放
    playLive() {
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      // console.log('this.code', this.code)
      imosSdk.playLive(
        this.iframeObjId, // 播放窗格的Id
        this.code, // 摄像头编码
        this.code, // 需要显示的标题名称
        (e) => {
          // console.log('播放实时视频的回调结果', e)
        },
        this.streamType
      )
    },
  },
  watch: {
    code(val) {
      this.getConfig()
    },
  },
}
</script>

<style scope lang="scss">
.imosSdk-video {
  height: 100% !important;
  width: 100% !important;
  border-width: 0 !important;
}
.btnCont {
  // width: 250px;
  // display: flex;
  align-items: center;
}
.controlImg {
  width: 30px;
  &_up {
    transform: rotate(90deg);
  }
  &_right {
    margin-left: 30px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
  }
}
.tc {
  text-align: center;
  text-align: -webkit-center;
}
</style>
